import http from '@/services/http'
import * as types from './startup-list.types'
import { fromPairs } from 'lodash'
import moment from 'moment'
import store from 'store'

export default {
  namespaced: true,
  state: {
    fetchInProgress: false,
    actionInProgress: false,
    startups: [],
    count: null,
    page: null,
    recentFetchInProgress: false,
    recentStartups: [],
    recentStartupsMap: {},
    recentCount: null,
    recentPage: null,
    fetchfollowedCountInProgress: false,
    followedCount: null,
    filters: {},
    filtersVisible: false,
  },
  getters: {
    isStartupNew: (state) => {
      return (startupId) => {
        const startup = state.recentStartupsMap[startupId]
        if (startup) {
          return isStartupRecentAndNotSeenYet(startup)
        } else {
          return false
        }
      }
    },
  },
  mutations: {
    [types.START_FETCH](state, page) {
      state.fetchInProgress = true
      state.page = page
    },
    [types.SET_STARTUP_LIST_DATA](state, { results, count }) {
      state.startups = results
      state.count = count
    },
    [types.STOP_FETCH](state) {
      state.fetchInProgress = false
    },
    [types.SET_RECENT_STARTUP_LIST_DATA](state, { results, count }) {
      state.recentStartups = results
      state.recentCount = count
      state.recentStartupsMap = fromPairs(
        results.map((startup) => {
          return [startup.id, startup]
        }),
      )
    },
    [types.START_RECENT_FETCH](state, page = 1) {
      state.recentFetchInProgress = true
      state.recentPage = page
    },
    [types.STOP_RECENT_FETCH](state) {
      state.recentFetchInProgress = false
    },
    [types.START_FOLLOWING](state, { startup }) {
      state.followedCount += 1
      const idx = state.startups.map((s) => s.id).indexOf(startup.id)
      state.startups.splice(idx, 1, { ...startup, follows: true })
      const recentIdx = state.recentStartups
        .map((s) => s.id)
        .indexOf(startup.id)
      if (recentIdx >= 0) {
        state.recentStartups.splice(recentIdx, 1, { ...startup, follows: true })
      }
    },
    [types.STOP_FOLLOWING](state, { startup }) {
      state.followedCount -= 1
      const idx = state.startups.map((s) => s.id).indexOf(startup.id)
      state.startups.splice(idx, 1, { ...startup, follows: false })
      const recentIdx = state.recentStartups
        .map((s) => s.id)
        .indexOf(startup.id)
      if (recentIdx >= 0) {
        state.recentStartups.splice(recentIdx, 1, {
          ...startup,
          follows: false,
        })
      }
    },
    removeStartup(state, { id }) {
      state.startups = state.startups.filter((s) => s.id != id)
      state.count = state.startups.length
    },
    startAction(state) {
      state.actionInProgress = true
    },
    stopAction(state) {
      state.actionInProgress = false
    },
    showFilters(state) {
      state.filtersVisible = true
    },
    hideFilters(state) {
      state.filtersVisible = false
    },
    clearStartups(state) {
      state.startups = []
      state.count = 0
    },

    setFilters(state, filters) {
      state.filters = filters
    },
    clearFilters(state) {
      state.filters = {}
    },

    START_FETCH_FOLLOWS_COUNT(state) {
      state.fetchfollowedCountInProgress = true
    },
    STOP_FETCH_FOLLOWS_COUNT(state) {
      state.fetchfollowedCountInProgress = false
    },
    SET_FOLLOWS_COUNT(state, count) {
      state.followedCount = count
    },

    promoted(state, startup) {
      state.startups = state.startups.map((s) => {
        if (s.id === startup.id) {
          s.has_promode = true
        }
        return s
      })
    },
    demoted(state, startup) {
      state.startups = state.startups.map((s) => {
        if (s.id === startup.id) {
          s.has_promode = false
        }
        return s
      })
    },

    setStartupAttrs(state, { startupId, attrs }) {
      state.startups = state.startups.map((s) => {
        if (s.id === startupId) {
          return { ...s, ...attrs }
        } else {
          return s
        }
      })
    },

    setRecentStartupAttrs(state, { startupId, attrs }) {
      state.recentStartups = state.recentStartups.map((s) => {
        if (s.id === startupId) {
          return { ...s, ...attrs }
        } else {
          return s
        }
      })
    },

    obfuscateStartups(state, { startupIds }) {
      state.startups = state.startups.map((s) => {
        if (startupIds.includes(s.id)) {
          return { ...s, is_obfuscated: true }
        } else {
          return s
        }
      })
      state.recentStartups = state.recentStartups.map((s) => {
        if (startupIds.includes(s.id)) {
          return { ...s, is_obfuscated: true }
        } else {
          return s
        }
      })
    },

    deobfuscateStartups(state, { startupIds }) {
      state.startups = state.startups.map((s) => {
        if (startupIds.includes(s.id)) {
          return { ...s, is_obfuscated: false }
        } else {
          return s
        }
      })
      state.recentStartups = state.recentStartups.map((s) => {
        if (startupIds.includes(s.id)) {
          return { ...s, is_obfuscated: false }
        } else {
          return s
        }
      })
    },
  },
  actions: {
    async fetch({ commit }, filters) {
      filters = filters || {}
      filters.page = filters.page || 1
      const url = '/startups'
      return await fetchStartups({ commit, url, filters })
    },
    async fetchRecent({ commit }, { organizationId, filters }) {
      filters = filters || {}
      filters.page = filters.page || 1
      const url = `/organizations/${organizationId}/recent-startups`
      return await fetchRecentStartups({ commit, url, filters })
    },
    async fetchfollowedCount({ commit }) {
      const filters = {}
      filters.page = filters.page || 1
      filters.followed_only = true
      const url = '/startups'
      commit('START_FETCH_FOLLOWS_COUNT', filters.page)
      const request = http.getAuthed(url, filters)
      try {
        const response = await request
        commit('SET_FOLLOWS_COUNT', response.data.count)
      } catch (error) {
        // TODO: Handle error
      } finally {
        commit('STOP_FETCH_FOLLOWS_COUNT')
      }
    },
    async fetchForOrganization({ commit }, { organizationId, filters = {} }) {
      filters.page = filters.page || 1
      const url = `/organizations/${organizationId}/startups`
      return fetchStartups({ commit, url, filters })
    },
    startFollowing({ commit }, { startup }) {
      commit(types.START_FOLLOWING, { startup })
      return http.postAuthed(`/startups/${startup.id}/start-following`)
    },
    stopFollowing({ commit }, { startup }) {
      commit(types.STOP_FOLLOWING, { startup })
      return http.postAuthed(`/startups/${startup.id}/stop-following`)
    },
    async promote({ commit }, { startup }) {
      commit('promoted', startup)
      return await http.postAuthed(`/startups/${startup.id}/enable-promode`)
    },
    async demote({ commit }, { startup }) {
      commit('demoted', startup)
      return await http.postAuthed(`/startups/${startup.id}/disable-promode`)
    },

    async obfuscateOrganizationStartups(
      { commit },
      { organizationId, startupIds },
    ) {
      const url = `/organizations/${organizationId}/startups/obfuscate`
      const data = { startup_ids: startupIds }

      runAction({
        commit,
        url,
        data,
        onSuccess() {
          commit('obfuscateStartups', { startupIds })
        },
      })
    },

    async deobfuscateOrganizationStartups(
      { commit },
      { organizationId, startupIds },
    ) {
      const url = `/organizations/${organizationId}/startups/deobfuscate`
      const data = { startup_ids: startupIds }

      runAction({
        commit,
        url,
        data,
        onSuccess() {
          commit('deobfuscateStartups', { startupIds })
        },
      })
    },

    async markStartupAsSeen(
      { commit, dispatch },
      { organizationId, startupId },
    ) {
      const request = http.postAuthed(
        `/organizations/${organizationId}/startups/${startupId}/seen`,
      )
      try {
        await commit(types.START_RECENT_FETCH)
        await request
        dispatch('fetchRecent', { organizationId })
      } catch (error) {
        await commit(types.STOP_RECENT_FETCH)
      }
    },

    removeStartup({ commit }, { id }) {
      commit('removeStartup', { id })
    },
  },
}

async function runAction({ commit, url, data, onSuccess, onError }) {
  commit('startAction')
  const request = http.postAuthed(url, data)
  const noop = () => {}
  try {
    const response = await request
    onSuccess = onSuccess || noop
    onSuccess({ response })
  } catch (error) {
    onError = onError || noop
    onError({ commit, data, error })
  } finally {
    commit('stopAction')
  }
}

async function fetchStartups({ commit, url, filters }) {
  filters = filters || { page: 1 }
  const noStartupStopIndicator = !!filters.noStartupStopIndicator
  if (noStartupStopIndicator) {
    delete filters.noStartupStopIndicator
  } else {
    commit(types.START_FETCH, filters.page)
  }
  const request = http.getAuthed(url, filters)
  try {
    const response = await request
    commit(types.SET_STARTUP_LIST_DATA, response.data)
  } catch (error) {
    // TODO: Handle error
  } finally {
    if (!noStartupStopIndicator) {
      commit(types.STOP_FETCH)
    }
  }
}

async function fetchRecentStartups({ commit, url, filters }) {
  filters = filters || { page: 1 }
  const noStartupStopIndicator = !!filters.noStartupStopIndicator
  if (noStartupStopIndicator) {
    delete filters.noStartupStopIndicator
  } else {
    commit(types.START_RECENT_FETCH, filters.page)
  }
  const request = http.getAuthed(url, filters)
  try {
    const response = await request
    commit(types.SET_RECENT_STARTUP_LIST_DATA, response.data)
  } catch (error) {
    // TODO: Handle error
  } finally {
    if (!noStartupStopIndicator) {
      commit(types.STOP_RECENT_FETCH)
    }
  }
}

function hasBeenAddedRecently(startup) {
  return (
    moment(startup.added_at) >=
    moment().subtract(
      store.state.common.data.constants.NEW_STARTUPS_AGE_IN_DAYS,
      'day',
    )
  )
}
function hasAlreadyBeenSeen(startup) {
  return !!startup.seen_at
}
export function isStartupRecentAndNotSeenYet(startup) {
  return hasBeenAddedRecently(startup) && !hasAlreadyBeenSeen(startup)
}

export function emptyFilterForm() {
  return {
    search: '',
    location: '',
    sector: [],
    stage: [],
    previous_rounds_size: [0, 9],
    round_size: [0, 9],
    product_type: [],
    business_type: [],
    annual_revenue: [0, 9],
    monthly_recurring_revenue: [0, 9],
    published: [],
    has_documents: [],
    interest_state: [],
    visited: false,
    profile_progress: [0, 100],
    ordering: '',
  }
}
